import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { ZERO } from 'lib/core/resources/constants'
import { Price } from 'lib/shared'
import { getCartId } from 'lib/core/data/quote/cartId/selectors'
import { getCart } from 'lib/core/data/quote/cart/selectors'
import { Tax } from './components/Tax'
import { Table } from './styled'

interface GiftCard {
  applied_balance: {
    value: number
  }
}

export const TotalsTable = () => {
  const cartId = useSelector(getCartId)
  const cart = useSelector(getCart(cartId))

  if (!cart?.data) {
    return null
  }

  const { data } = cart
  const { prices, shippingAddress, appliedGiftCards } = data
  const {
    discount,
    appliedTaxes,
    grandTotal,
    subtotalExcludingTax,
    subtotalIncludingTax
  } = prices || {}

  const giftCardDiscount = {
    value: appliedGiftCards?.reduce((total: number, giftCard: GiftCard) => {
      return total + giftCard.applied_balance.value
    }, 0) ?? 0,
    currency: appliedGiftCards?.length && appliedGiftCards[0].currency
  }

  const {
    amount: shippingAmount,
    carrier_title: carrierTitle,
    method_title: methodTitle
  } = shippingAddress?.selectedShippingMethod ?? {}

  return (
    <Table>
      <tbody>
        {subtotalExcludingTax && (
          <tr>
            <th>
              <FormattedMessage id='quote.totals.subtotal' />
            </th>
            <td>
              <Price
                {...subtotalExcludingTax}
              />
            </td>
          </tr>
        )}

        {shippingAmount && (
          <tr>
            <th>
              <FormattedMessage id='quote.totals.shipping' />
              <br />
              ({carrierTitle && `${carrierTitle} - `}{methodTitle})
            </th>
            <td>
              <Price
                {...shippingAmount}
              />
            </td>
          </tr>
        )}

        {!!appliedTaxes?.length && (
          <Tax
            appliedTaxes={appliedTaxes}
            subtotalExcludingTax={subtotalExcludingTax}
            subtotalIncludingTax={subtotalIncludingTax}
          />
        )}

        {discount?.value !== ZERO && (
          <tr>
            <th>
              <FormattedMessage id='quote.totals.discount' />
            </th>
            <td>
              <Price
                {...discount}
              />
            </td>
          </tr>
        )}

        {giftCardDiscount.value !== ZERO && (
          <tr>
            <th>
              <FormattedMessage id='quote.totals.giftCardDiscount' />
            </th>
            <td>
              <Price
                {...giftCardDiscount}
              />
            </td>
          </tr>
        )}

        {grandTotal && (
          <tr>
            <th>
              <FormattedMessage id='quote.totals.grandTotal' />
            </th>
            <td>
              <Price
                {...grandTotal}
              />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}
